import Vue from 'vue'
import Vuex from 'vuex'
import { Howl, Howler } from 'howler'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    numScenes: 7,
    currentScene: 1,
    beginButton: true,
    muted: false,
    trackTime: 0,
    trackInterval: null,
    audio: {
      scene1: new Howl({
        src: ['audio/scene-1.mp3'],
        html5: true
      }),
      scene2: new Howl({
        src: ['audio/scene-2.mp3'],
        html5: true
      }),
      scene3: new Howl({
        src: ['audio/scene-3.mp3'],
        html5: true
      }),
      scene4: new Howl({
        src: ['audio/scene-4.mp3'],
        html5: true
      }),
      scene5: new Howl({
        src: ['audio/scene-5.mp3'],
        html5: true
      }),
      scene6: new Howl({
        src: ['audio/scene-6.mp3'],
        html5: true
      }),
      scene7: new Howl({
        src: ['audio/scene-7.mp3'],
        volume: 0.7
      }),
      click: new Howl({
        src: ['audio/click.mp3'],
        html5: true
      }),
      hover: new Howl({
        src: ['audio/swish.mp3'],
        html5: true
      }),
    }
  },
  mutations: {
    SET_CURRENT_SCENE (state, payload) {
      state.currentScene = payload
    },
    PREVIOUS_SCENE (state) {
      state.currentScene--
    },
    NEXT_SCENE (state) {
      state.currentScene++
    },
    HIDE_BEGIN_BUTTON (state) {
      state.beginButton = false
    },
    MUTE (state) {
      state.muted = true
    },
    UNMUTE (state) {
      state.muted = false
    },
    RESET_TRACK_TIME (state) {
      state.trackTime = 0
    },
    RESET_TRACK_INTERVAL (state) {
      clearInterval(state.trackInterval)
      state.trackInterval = setInterval(() => {
        state.trackTime += 0.5
      }, 500)
    },
    CLEAR_TRACK_INTERVAL (state) {
      clearInterval(state.trackInterval)
    }
  },
  actions: {
    begin ({ state, commit }) {
      commit('HIDE_BEGIN_BUTTON')
      state.audio.scene1.play()
      commit('RESET_TRACK_INTERVAL')
      commit('RESET_TRACK_TIME')
    },
    previousScene ({ state, commit, dispatch }) {
      if (state.currentScene > 1) {
        commit('PREVIOUS_SCENE')
      }
      dispatch('playAudioByScene')
    },
    nextScene({ state, commit, dispatch }) {
      if (state.currentScene < state.numScenes) {
        commit("NEXT_SCENE");
      } else {
        if (window.history.length > 1) {
          window.history.go(-1)
        } else {
          commit('SET_CURRENT_SCENE', 1)
        }
      }
      dispatch("playAudioByScene");
      if (state.currentScene == 3) {
        state.audio[`click`].play()
      }
    },
    toggleMute ({ state, commit }) {
      if (state.muted) {
        Howler.mute(false)
        commit('UNMUTE')
      } else {
        Howler.mute(true)
        commit('MUTE')
      }
    },
    stopAllAudio ({ state, commit }) {
      Object.keys(state.audio).forEach((key) => {
        state.audio[key].stop()
      })
      commit('CLEAR_TRACK_INTERVAL')
      commit('RESET_TRACK_TIME')
    },
    playAudioByScene ({ state, commit, dispatch }) {
      dispatch('stopAllAudio')
      if (typeof state.audio[`scene${state.currentScene}`] !== 'undefined') {
        state.audio[`scene${state.currentScene}`].play()
        commit('RESET_TRACK_INTERVAL')
        commit('RESET_TRACK_TIME')
      }
    },
    playAudioByName ({ state }, name) {
      if (typeof state.audio[name] !== 'undefined') {
        state.audio[name].play()
      }
    },
    setVolumeByName({ state }, payload) {
      // console.log(payload)
      if (typeof state.audio[payload.name] !== "undefined") {
        state.audio[payload.name].volume(payload.volume);
      } else {
        Object.keys(state.audio).forEach(key => {
          state.audio[key].stop();
        })
      }
    },
    playHover({ state }) {
      state.audio[`hover`].play()
    }
  }
})

export default store